import React, {memo, ReactNode} from 'react';
import './index.scss';
import {NavLink} from 'react-router-dom';
import {onClickHandler} from '../../utils/onclick';
import {WindowUtil} from "../../utils/window";

type Props = {
    routerLink?: string;
    onClick?: (e?: any) => void;
    title: string;
    iconUrl?: string;
    passiveIconUrl?: string;
    closedIconUrl?: string;
    exact: boolean;
    children?: ReactNode;
    status?: string
    isActive?: boolean;
};

export const MenuItem = memo(function MenuItem({routerLink, onClick, title, iconUrl, children, exact, status, isActive}: Props) {
    const content = (
        <>
           {isActive && <span className='menuitem-status'>{status}</span>}
            <img src={iconUrl} alt=''/>
            <div className="menuitem-title">
                <span>{title}</span>
            </div>
        </>
    );

    function linkCatcher() {
        console.log(routerLink)
        if (routerLink.includes("camera") || routerLink.includes("intercom")) {
            console.log("start video")
        } else {
            window.stop();
            window.close();
            console.log("stop video")
        }

    }

    return (
        <div onClick={linkCatcher}>
            {
                renderIf(!!routerLink)(() =>
                        <NavLink className='menuitem' exact={exact} to={routerLink} {...onClickHandler(onClick)}>
                            {content}
                        </NavLink>,
                    () =>
                        <button className='menuitem' {...onClickHandler(onClick)}>
                            {content}
                        </button>,
                )
            }
            {children}
        </div>
    );
});
